import { render, staticRenderFns } from "./make-payment.vue?vue&type=template&id=295ed608"
import script from "./make-payment.vue?vue&type=script&lang=js"
export * from "./make-payment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports